import { useEffect } from "react";
import { API_FILE_URL } from "../api/config";

const QrRedirect = ({ location }) => {
  const targetUrl = `${API_FILE_URL.replace(/\/+$/, "")}${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    window.location.replace(targetUrl);
  }, [targetUrl]);

  return null;
};

export default QrRedirect;
